import { computed, reactive } from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';

library.add(faPlay);
library.add(faChevronDown);

export default {
  name: 'EventReplaySessionsItemComponent',
  props: {
    session: {
      type: Object,
      required: true,
    },
    open: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: null,
    },
    columns: {
      type: Number,
      required: false,
      default: 1,
    },
    dayColumnStyle: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: { FontAwesomeIcon },
  emits: ['toggled', 'play'],
  setup(props) {

    const state = reactive({
      session: props.session,
      open: props.open,
      isPlaceholder: computed(() => { return 'placeholder' === props.session.video_key}),
      instructorText: computed(() => {
        if (props.session.session_instructors.length) {
          return formatInstructors(props.session);
        } else if (props.session.instructors !== null && props.session.instructors !== '') {
          return props.session.instructors;
        }
        return false;

      }),
      hasDescription: computed(() => {
        if (props.session.description !== null && props.session.description !== '') {
          return true;
        }

        return false;
      }),
      styleObject: computed(() => {
        return {
          flexBasis: (100 / props.columns) + '%',
        };
      }),
      thumbnailStyleObject: computed(() => {
        if (props.session.video_key) {
          if (!state.isPlaceholder) {
            return {
              backgroundImage: `url(https://cdn.jwplayer.com/v2/media/${props.session.video_key}/poster.jpg?width=320)`,
            }
          }
        }
        return {};
      }),
    });


    const formatInstructors = (session) => {
      if (session.session_instructors && session.session_instructors.length) {
        const titles = session.session_instructors.map(instructor => instructor.title);
        return titles.join(', ').replace(/,(?=[^,]*$)/, ' &');
      }

      return session.instructors;
    };

    return { state };
  },
  methods: {
    close: async function() {
      this.state.open = false;
      this.$emit('toggled', this.state.open);
    },
    toggle: async function() {
      this.state.open = !this.state.open;
      this.$emit('toggled', this.state.open);
    },
    playVideo: async function() {
      this.$emit('play', this.state.session.video_key);
    }
  },
};
